import NavBar from '@components/common/navbar'
import FirstFold from '@components/national-coding-olympiad-2021/thank-you-page/first-fold'
import ResourceFold from '@components/national-coding-olympiad-2021/thank-you-page/resource-fold'
import Banner from '@components/national-coding-olympiad-2021/thank-you-page/banner'
import Footer from '@components/common/footer'
import { QUICK_REFRESHER_VIDEO } from '@lib/data/nco-thank-you-page'
import { NextSeo } from 'next-seo'
import { refresherVideos } from '@lib/seo'

const QuickRefresherVideosThankYouPage = () => (
  <>
    <NextSeo {...refresherVideos} />
    <NavBar isSticky />
    <FirstFold
      title="Quick refresher videos"
      subHeading="Refresh your coding knowledge with these informative concept-based videos hand-picked to help you win."
    />
    <div style={{ background: '#FBFBFB' }}>
      <ResourceFold
        resourceData={QUICK_REFRESHER_VIDEO}
        imagePath="/images/national-coding-olympiad/thank-you-page/quick-refresher-videos/"
        ctaText="Watch video"
      />
    </div>
    <Banner />
    <Footer />
  </>
)

export default QuickRefresherVideosThankYouPage
